module.exports = __webpack_public_path__ + "img/2026-03-24c_1.23ac4968.jpg";